import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="bg-[#FAF7F2] py-20 px-4 border-t border-[#e5e0d8]" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-12 text-center" data-id="element-3">
          Para quién es (y para quién no)
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-4">
          {/* Para ti */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-xl shadow-sm border-t-4 border-[#1B2A4A]" data-id="element-5">
            <h3 className="text-2xl font-bold text-[#1B2A4A] mb-6 flex items-center gap-2" data-id="element-6">
              <span className="bg-[#1B2A4A] text-white rounded-full p-1" data-id="element-7">
                <Check className="w-5 h-5" data-id="element-8" />
              </span>
              Esto es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-9">
              {['Vives con ingreso fijo (Seguro Social/pensión)', 'Te estresa el fin de mes', 'Odias las apps y el “presupuesto perfecto”', 'Quieres una solución práctica, imprimible y humana'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-[#2D2A26]" data-id="element-10">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-11" />
                  <span data-id="element-12">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* No para ti */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-xl shadow-sm border-t-4 border-[#C94040]" data-id="element-13">
            <h3 className="text-2xl font-bold text-[#C94040] mb-6 flex items-center gap-2" data-id="element-14">
              <span className="bg-[#C94040] text-white rounded-full p-1" data-id="element-15">
                <X className="w-5 h-5" data-id="element-16" />
              </span>
              Esto NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-17">
              {['Quieres inversiones, trading, criptos', 'Quieres “hacerte rica rápido”', 'No estás dispuesta a mirar tus números 10–15 minutos al día (por 14 días)'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-[#2D2A26]" data-id="element-18">
                  <X className="w-6 h-6 text-[#C94040] flex-shrink-0 mt-0.5" data-id="element-19" />
                  <span data-id="element-20">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}